<template>
  <v-container fluid class="redirectToApi">
    <v-row>
      <v-col cols="12" md="8" class="mx-auto">
        <v-row>
          <v-col cols="12" md="6">
            <v-card
                :loading="loading"
                class="mx-auto my-12"
                height="90%"
            >
              <template slot="progress">
                <v-progress-linear
                    color="deep-purple"
                    height="10"
                    indeterminate
                ></v-progress-linear>
              </template>
              <v-card-title><v-icon color="error">mdi-contactless-payment</v-icon> <v-divider class="error ma-1" vertical/> C2B/B2C/B2B</v-card-title>
              <v-divider/>

              <v-card-text>
                <div>
                  <strong>C2B:</strong> Customers can pay to the Business/Merchant through their SasaPay PayBills and Till Numbers.<br/>
                  <strong>B2C:</strong> Business/Merchant can send money to Customers through SasaPay,MNOs,and Banks. <br/>
                  <strong>B2B:</strong> Business/Merchant can send money to other SasaPay Businesses/Merchants Tills or PayBills. <br/>

                </div>
              </v-card-text>

              <v-divider class="mx-4"></v-divider>

              <v-card-title>Possible Use Cases</v-card-title>

              <v-card-text>
                <v-chip-group
                    v-model="selection"
                    active-class="deep-purple accent-4 white--text"
                    column
                >
                  <v-chip active>All Organisations</v-chip>
                </v-chip-group>
              </v-card-text>
              <v-divider/>

              <v-card-actions>
               <v-spacer/>
                <v-btn
                    color="primary"
                    @click="explore"
                    bottom
                    absolute
                    right
                >
                  <v-icon class="white--text">mdi-arrow-right</v-icon>Explore
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="12" md="6">
            <v-card
                :loading="loadingWaas"
                class="mx-auto my-12 "
                height="90%"
            >
              <template slot="progress">
                <v-progress-linear
                    color="deep-purple"
                    height="10"
                    indeterminate
                ></v-progress-linear>
              </template>

              <v-card-title><v-icon color="error">mdi-wallet</v-icon> <v-divider class="error ma-1" vertical/> Wallet As A Service (WAAS)</v-card-title>

              <v-card-text>
                <div>
                  Wallet as a Service (WaaS) enables you to build your financial services or payment solutions on top of SasaPay, which is a secure, licensed, and scalable infrastructure.
                </div>
                <v-divider/>
                <div>
                  Developing a payment system is a journey with complex challenges and requiring significant scale in standards and conforming to various regulations and controls
                </div>
                <v-divider/>
                <div>
                  Sasapay have handled all the heavy lifting for you including compliance,standards and aml checks.
                </div>
              </v-card-text>

              <v-divider class="mx-4"></v-divider>

              <v-card-title>Possible Use Cases</v-card-title>

              <v-card-text>
                <v-chip-group
                    v-model="selection"
                    active-class="deep-purple accent-4 white--text"
                    column
                >
                  <v-chip>FinTechs</v-chip>

                  <v-chip>Banks</v-chip>

                  <v-chip>SACCOS</v-chip>
                </v-chip-group>
              </v-card-text>
              <v-divider/>

              <v-card-actions>
                <v-spacer/>
                <v-btn
                    color="primary"
                    @click="exploreWaas"
                    bottom
                    absolute
                    right
                >
                  <v-icon class="white--text">mdi-arrow-right</v-icon>Explore
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "RedirectToPortal",
  data: ()=>({
    loading: false,
    loadingWaas: false,
    selection: 1,
  }),
  methods:{
    explore () {
      this.loading = true
      localStorage.setItem("isWaas",false)
      setTimeout(() => {
        this.loading = false
        this.$router.push({name:"Introduction"})
            .then(()=>this.$router.go())
      }, 2000)
    },
    exploreWaas () {
      this.loadingWaas = true
      localStorage.setItem("isWaas",true)

      setTimeout(() => {
        this.loading = false
        this.$router.push({name:"Introduction"})
            .then(()=>this.$router.go())
      }, 2000)
    },
  }
}
</script>

<style scoped>
.redirectToApi{
  background: no-repeat #049CE4 ;
  background-size: cover;
  height: 100%;
  opacity: 0.8;
}
</style>